import styled from 'styled-components'

export const BackgroundPreviewCanvas = styled.canvas<{ size: number }>`
  display: block;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
`
